import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../App";
import { 
  FlaskConical, 
  LayoutDashboard, 
  Beaker, 
  BookOpen, 
  Upload, 
  LogOut
} from "lucide-react";
import { Button } from "./ui/button";

export default function Sidebar() {
  const location = useLocation();
  const { user, logout } = useAuth();

  const navItems = [
    { path: "/dashboard", icon: LayoutDashboard, label: "Dashboard" },
    { path: "/inventory", icon: Beaker, label: "Inventory" },
    { path: "/recipe-builder", icon: FlaskConical, label: "Recipe Builder" },
    { path: "/my-recipes", icon: BookOpen, label: "My Recipes" },
    { path: "/import", icon: Upload, label: "Import" },
  ];

  const isActive = (path) => {
    if (path === "/recipe-builder") {
      return location.pathname.startsWith("/recipe-builder");
    }
    return location.pathname === path;
  };

  return (
    <aside className="fixed left-0 top-0 h-screen w-64 bg-noir-paper border-r border-zinc-800 flex flex-col z-40">
      {/* Logo */}
      <div className="p-6 border-b border-zinc-800">
        <Link to="/dashboard" className="flex items-center gap-2">
          <FlaskConical className="w-6 h-6 text-amber" />
          <span className="font-playfair text-xl font-semibold text-white">Scentic</span>
        </Link>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 space-y-1">
        {navItems.map((item) => (
          <Link key={item.path} to={item.path}>
            <Button
              variant="ghost"
              data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
              className={`w-full justify-start gap-3 ${
                isActive(item.path)
                  ? "bg-amber/10 text-amber hover:bg-amber/20 hover:text-amber"
                  : "text-zinc-400 hover:text-white hover:bg-zinc-800/50"
              }`}
            >
              <item.icon className="w-4 h-4" />
              {item.label}
            </Button>
          </Link>
        ))}
      </nav>

      {/* User Section */}
      <div className="p-4 border-t border-zinc-800">
        <div className="flex items-center gap-3 mb-4 p-2">
          {user?.picture ? (
            <img 
              src={user.picture} 
              alt={user.name}
              className="w-8 h-8 rounded-full"
            />
          ) : (
            <div className="w-8 h-8 bg-amber/20 rounded-full flex items-center justify-center text-amber font-medium">
              {user?.name?.charAt(0) || "U"}
            </div>
          )}
          <div className="flex-1 min-w-0">
            <p className="text-white text-sm font-medium truncate">{user?.name}</p>
            <p className="text-zinc-500 text-xs truncate">{user?.email}</p>
          </div>
        </div>
        
        <Button
          variant="ghost"
          data-testid="logout-btn"
          onClick={logout}
          className="w-full justify-start gap-3 text-zinc-400 hover:text-red-400 hover:bg-red-500/10"
        >
          <LogOut className="w-4 h-4" />
          Sign Out
        </Button>
      </div>
    </aside>
  );
}
